import _ from 'underscore';
import { AdStrengthSuggestionController } from './asset-suggestion-picker';

export const containerExists = container => (!_.isEmpty(container) && container.length > 0);

let controller = null;

/*
 * Attaches focus, input event listeners to ad text fields
 */
export const attachAdStrengthSuggestionHelpers = ({
  element,
  field,
  viewModel,
  pageContext,
  assetType,
  i18n,
  activityLogger,
  scenario,
}) => {
  // add the class so that click in the input will not trigger picker to be hidden
  element.$el.addClass('ad-strength-suggestion-helper-area');

  const attachedFunc = (event) => {
    if (!event) {
      return;
    }
    const { type, target, key } = event;

    const {
      selectionStart, selectionEnd,
    } = target || {};
    // Ignore if any text is selected, we are only interested in the cursor
    if (selectionStart !== selectionEnd) {
      return;
    }

    // Ignore escape key up since it shouldn't prompt any helper
    if (type === 'keyup' && key === 'Escape') {
      return;
    }

    // Delay creating controller since the container won't be available until view is loaded
    if (controller === null) {
      controller = new AdStrengthSuggestionController({
        containerSelector: 'div.ad-properties-section',
        pageContext,
        i18n,
        activityLogger,
      });
    }

    controller.getAdStrengthSuggestion({
      assetType,
      target,
      field,
      viewModel,
      element,
      scenario,
    });
  };

  element.on('input-changed', _.debounce(attachedFunc, 300));
  element.on('input-focused', attachedFunc);
};

export const attachAdStrengthSuggestionHelperForURL = ({
  element,
  view,
  viewModel,
  pageContext,
  i18n,
  activityLogger,
  scenario,
}) => {
  // add the class so that click in the input will not trigger picker to be hidden
  element.$el.addClass('ad-strength-suggestion-helper-area');

  const onUrlChanged = () => {
    // Delay creating controller since the container won't be available until view is loaded
    if (controller === null) {
      controller = new AdStrengthSuggestionController({
        containerSelector: 'div.ad-properties-section',
        pageContext,
        i18n,
        activityLogger,
      });
    }

    controller.getAdStrengthSuggestionForURL({
      view,
      viewModel,
      scenario,
    });
  };

  onUrlChanged();

  return onUrlChanged;
};

export const clearAdStrengthSuggestionController = () => { controller = null; };
